// extracted by mini-css-extract-plugin
module.exports = {"icons":"styles_icons__2zTLL"};